var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyDraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 84,
    r: 63,
    fill: "#6221EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.274,
    width: 126,
    height: 126,
    rx: 63,
    transform: "rotate(64.0275 113.274 0)",
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.627 128.047H41.3725C38.9579 128.047 37 126.089 37 123.674V45.109C37 42.3543 39.2332 40.1211 41.9871 40.1211H126.276C128.885 40.1211 131 42.236 131 44.845V123.674C131 126.089 129.042 128.047 126.627 128.047Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.277 40.1211H124.083C124.223 40.5736 124.298 41.0541 124.298 41.5526V126.615C124.298 127.114 124.223 127.594 124.083 128.047H126.628C129.043 128.047 131 126.089 131 123.674V44.8443C131 42.236 128.885 40.1211 126.277 40.1211Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 57.0418H131V44.6256C131 42.1378 128.983 40.1211 126.495 40.1211H41.5045C39.0167 40.1211 37 42.1378 37 44.6256L37 57.0418Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.496 40.1211H124.083C124.223 40.5736 124.298 41.0541 124.298 41.5526V57.0418H131V44.6256C131 42.1378 128.983 40.1211 126.496 40.1211Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6209 48.5813C51.6209 50.4251 50.1263 51.9204 48.2818 51.9204C46.4379 51.9204 44.9434 50.4251 44.9434 48.5813C44.9434 46.7375 46.4379 45.2422 48.2818 45.2422C50.1263 45.2422 51.6209 46.7375 51.6209 48.5813Z",
    fill: "#E53935"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9243 48.5813C62.9243 50.4251 61.429 51.9204 59.5852 51.9204C57.7407 51.9204 56.2461 50.4251 56.2461 48.5813C56.2461 46.7375 57.7407 45.2422 59.5852 45.2422C61.429 45.2422 62.9243 46.7375 62.9243 48.5813Z",
    fill: "#F6D867"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2271 48.5813C74.2271 50.4251 72.7318 51.9204 70.8879 51.9204C69.0441 51.9204 67.5488 50.4251 67.5488 48.5813C67.5488 46.7375 69.0441 45.2422 70.8879 45.2422C72.7318 45.2422 74.2271 46.7375 74.2271 48.5813Z",
    fill: "#00C853"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37 57.043V123.543C37 126.031 39.0167 128.048 41.5045 128.048H67.549V57.043H37Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8145 57.043H67.549V128.048H64.8145V57.043Z",
    fill: "#EBECF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6506 81.7216H74.8626C74.0594 81.7216 73.4082 81.0705 73.4082 80.2672V65.4349C73.4082 64.6317 74.0594 63.9805 74.8626 63.9805H94.6506C95.4538 63.9805 96.105 64.6317 96.105 65.4349V80.2672C96.105 81.0705 95.4538 81.7216 94.6506 81.7216Z",
    fill: "#6221EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6508 63.9805H91.2148C91.3454 64.2164 91.4207 64.4868 91.4207 64.7751V80.927C91.4207 81.2153 91.3454 81.4864 91.2148 81.7216H94.6508C95.454 81.7216 96.1052 81.0705 96.1052 80.2672V65.4349C96.1052 64.6317 95.454 63.9805 94.6508 63.9805Z",
    fill: "#5317D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.71 81.7216H104.435C103.491 81.7216 102.725 80.9564 102.725 80.0112V65.6909C102.725 64.7464 103.491 63.9805 104.435 63.9805H123.71C124.655 63.9805 125.421 64.7464 125.421 65.6909V80.0112C125.421 80.9564 124.655 81.7216 123.71 81.7216Z",
    fill: "#6221EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.71 63.9805H120.542C120.759 64.2924 120.886 64.6697 120.886 65.0784V80.6244C120.886 81.0325 120.759 81.4104 120.542 81.7224H123.71C124.654 81.7224 125.42 80.9564 125.42 80.0112V65.6909C125.42 64.7464 124.654 63.9805 123.71 63.9805Z",
    fill: "#5317D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.966 107.061H74.8626C74.0594 107.061 73.4082 106.41 73.4082 105.607V89.2239C73.4082 88.4207 74.0594 87.7695 74.8626 87.7695H123.966C124.769 87.7695 125.42 88.4207 125.42 89.2239V105.607C125.42 106.41 124.769 107.061 123.966 107.061Z",
    fill: "#6221EA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.966 87.7695H120.7C120.773 87.956 120.814 88.1575 120.814 88.3691V106.462C120.814 106.673 120.772 106.875 120.7 107.061H123.966C124.769 107.061 125.421 106.41 125.421 105.607V89.2239C125.421 88.4207 124.769 87.7695 123.966 87.7695Z",
    fill: "#5317D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.065 120.031H74.8626C74.0594 120.031 73.4082 119.38 73.4082 118.576V115.283C73.4082 114.479 74.0594 113.828 74.8626 113.828H124.065C124.868 113.828 125.519 114.479 125.519 115.283V118.576C125.519 119.38 124.868 120.031 124.065 120.031Z",
    fill: "#EEEEFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.021 113.828H119.671C120.499 113.828 121.169 114.499 121.169 115.326V118.533C121.169 119.36 120.499 120.031 119.671 120.031H124.021C124.849 120.031 125.519 119.36 125.519 118.533V115.326C125.519 114.499 124.849 113.828 124.021 113.828Z",
    fill: "#EEEEFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.552 48.5826C122.552 47.7995 121.917 47.1641 121.133 47.1641H86.5846C85.8014 47.1641 85.166 47.7995 85.166 48.5826C85.166 49.3658 85.8014 50.0012 86.5846 50.0012H121.133C121.917 50.0012 122.552 49.3658 122.552 48.5826Z",
    fill: "#322352"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 66.5916H58.5418C59.1425 66.5916 59.6298 66.0068 59.6298 65.286C59.6298 64.5646 59.1425 63.9805 58.5418 63.9805H44.1808C43.5801 63.9805 43.0928 64.5646 43.0928 65.286C43.0928 66.0068 43.5801 66.5916 44.1808 66.5916Z",
    fill: "#322352"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 75.2947H58.5418C59.1425 75.2947 59.6298 74.7099 59.6298 73.9891C59.6298 73.2677 59.1425 72.6836 58.5418 72.6836H44.1808C43.5801 72.6836 43.0928 73.2677 43.0928 73.9891C43.0928 74.7099 43.5801 75.2947 44.1808 75.2947Z",
    fill: "#322352"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 83.9978H58.5418C59.1425 83.9978 59.6298 83.413 59.6298 82.6923C59.6298 81.9709 59.1425 81.3867 58.5418 81.3867H44.1808C43.5801 81.3867 43.0928 81.9709 43.0928 82.6923C43.0928 83.413 43.5801 83.9978 44.1808 83.9978Z",
    fill: "#322352"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 92.701H58.5418C59.1425 92.701 59.6298 92.1167 59.6298 91.3957C59.6298 90.6741 59.1425 90.0898 58.5418 90.0898H44.1808C43.5801 90.0898 43.0928 90.6741 43.0928 91.3957C43.0928 92.1167 43.5801 92.701 44.1808 92.701Z",
    fill: "#322352"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 64.2538,
    y1: 72.087,
    x2: 208.449,
    y2: 68.3594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9770E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6221EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDraft);
export default __webpack_public_path__ + "static/media/survey-draft.4d970af50ea64e432bfe1b19bddc4bc2.svg";
export { ForwardRef as ReactComponent };